import {createApp} from 'vue';
import pinia from '@/plugins/pinia';
import vuetify from '@/plugins/vuetify';
import router from '@/plugins/router';
import axios from '@/plugins/axios';
import network from '@/plugins/network';
import datepicker from '@/plugins/datepicker';
import CKEditor from '@ckeditor/ckeditor5-vue';

import App from './App.vue';

const app = createApp(App);

app.use(pinia);
app.use(vuetify);
app.use(router);
app.use(axios);
app.use(network);
app.use(datepicker);
app.use(CKEditor);

app.mount('#app');
